export interface CountryData {
  brandIdentifier: string;
  countryIso2Code: string;
  rootDomain: string;
  landingPageActive: boolean;
}

export const COUNTRIES: CountryData[] = [
  {
    brandIdentifier: "betpawa-uganda",
    countryIso2Code: "UG",
    rootDomain: "betpawa.ug",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-nigeria",
    countryIso2Code: "NG",
    rootDomain: "betpawa.ng",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-kenya",
    countryIso2Code: "KE",
    rootDomain: "betpawa.co.ke",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-tanzania",
    countryIso2Code: "TZ",
    rootDomain: "betpawa.co.tz",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-zambia",
    countryIso2Code: "ZM",
    rootDomain: "betpawa.co.zm",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-ghana",
    countryIso2Code: "GH",
    rootDomain: "betpawa.com.gh",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-cameroon",
    countryIso2Code: "CM",
    rootDomain: "betpawa.cm",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-zimbabwe",
    countryIso2Code: "ZW",
    rootDomain: "betpawa.co.zw",
    landingPageActive: false,
  },
  {
    brandIdentifier: "betpawa-drc",
    countryIso2Code: "CD",
    rootDomain: "betpawa.cd",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-rwanda",
    countryIso2Code: "RW",
    rootDomain: "betpawa.rw",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-senegal",
    countryIso2Code: "SN",
    rootDomain: "betpawa.sn",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-malawi",
    countryIso2Code: "MW",
    rootDomain: "betpawa.mw",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-benin",
    countryIso2Code: "BJ",
    rootDomain: "betpawa.bj",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-sierraleone",
    countryIso2Code: "SL",
    rootDomain: "sl.betpawa.com",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-angola",
    countryIso2Code: "AO",
    rootDomain: "https://www.betpawa.co.ao/",
    landingPageActive: false,
  },
  {
    brandIdentifier: "betpawa-mozambique",
    countryIso2Code: "MZ",
    rootDomain: "betpawa.co.mz",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-ivorycoast",
    countryIso2Code: "CI",
    rootDomain: "betpawa.ci",
    landingPageActive: false,
  },
  {
    brandIdentifier: "betpawa-congobrazzaville",
    countryIso2Code: "CG",
    rootDomain: "cg.betpawa.com",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-gabon",
    countryIso2Code: "GA",
    rootDomain: "betpawa.ga",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-lesotho",
    countryIso2Code: "LS",
    rootDomain: "ls.betpawa.com",
    landingPageActive: true,
  },
  {
    brandIdentifier: "betpawa-liberia",
    countryIso2Code: "LR",
    rootDomain: "betpawa.lr",
    landingPageActive: false,
  },
  {
    brandIdentifier: "betpawa-car",
    countryIso2Code: "CF",
    rootDomain: "cf.betpawa.com",
    landingPageActive: false,
  },
  {
    brandIdentifier: "betpawa-botswana",
    countryIso2Code: "BW",
    rootDomain: "betpawa.co.bw",
    landingPageActive: false,
  },
];
